import {
  faFileAlt,
  faFolderOpen,
  faHistory,
  faHome,
  faSearch,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { FaHistory } from "react-icons/fa";
import { Link, useLocation, useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { getLoanDetail } from "../../redux/slices/loan";
import {
  getCustomerLoanOffer,
  getLoanOfferMsg,
} from "../../redux/slices/loanOffers";

export default function SideBar() {
  const { loanDetails } = useSelector((state) => state.loanOffers);
  const { offerId } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getLoanOfferMsg(offerId));
  }, []);
  return (
    <>
      <div className="col-sm-12 col-md-12 col-lg-3">
        <div className="sidebar mb-4">
          {/* {loanDetails &&
            loanDetails?.loan_application_id &&
            loanDetails?.financer?.name && (
              <div className="px-3 pt-3 mb-3">
                <h3 className="h5">
              Non Reseidential Premises Loan - Variable Rate
            </h3>
                <p className="mt-3">
                  Application ID- {loanDetails?.loan_application_id}
                </p>
                <p className="mt-3">Financer- {loanDetails?.financer?.name}</p>
              </div>
            )} */}
          {/* <hr /> */}
          <ul className="nav flex-column" id="nav_accordion">
            <li
              className={
                location.pathname.includes("/loan/pendingqueries")
                  ? //  === "/loan/pendingqueries"
                    "nav-item active"
                  : "nav-item"
              }
            >
              <Link
                // to="/loan/pendingqueries"
                className={
                  location.pathname === "/loan/pendingqueries"
                    ? "nav-link active"
                    : "nav-link"
                }
              >
                <FontAwesomeIcon icon={faHistory} className="me-2" />
                Discussion Section
              </Link>
            </li>
            {/* <li
              className={
                location.pathname === "/loan/loanreview"
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link
                to="/loan/loanreview"
                className={
                  location.pathname === "/loan/loanreview"
                    ? "nav-link active"
                    : "nav-link"
                }
              >
                <FontAwesomeIcon icon={faSearch} className="me-2" />
                Loan Review
              </Link>
            </li>
            <li
              className={
                location.pathname === "/supplier"
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link
                to="/supplier"
                className={
                  location.pathname === "/supplier"
                    ? "nav-link active"
                    : "nav-link"
                }
              >
                <FontAwesomeIcon icon={faFolderOpen} className="me-2" />
                Documents
              </Link>
            </li>
            
            <li
              className={
                location.pathname === "/supplier"
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link
                to="/supplier"
                className={
                  location.pathname === "/supplier"
                    ? "nav-link active"
                    : "nav-link"
                }
              >
                <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                Pending Information
              </Link>
            </li>
            <li
              className={
                location.pathname === "/supplier"
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link
                to="/supplier"
                className={
                  location.pathname === "/supplier"
                    ? "nav-link active"
                    : "nav-link"
                }
              >
                <FontAwesomeIcon icon={faWallet} className="me-2" />
                View Fee Receipt
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
}
